var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChipYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 32,
    rx: 4.72706,
    fill: "url(#paint0_radial_865_737)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 0.318436L17.5 8.68125C17.5 8.68125 19.5 15.9987 17.5 22.2708L22.5 31.679L27.5 22.2708C27.5 22.2708 25.5 17.0441 27.5 8.68125C27.5 8.68125 22.5 0.318436 22.5 0.318436Z",
    stroke: "#68131B",
    strokeWidth: 1.22903,
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000457767 9.06521L17.5005 9.06521",
    stroke: "#68131B",
    strokeWidth: 1.22903,
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0012 9.06459L45.0012 9.06459",
    stroke: "#68131B",
    strokeWidth: 1.22903,
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00149536 21.8642L17.5015 21.8642",
    stroke: "#68131B",
    strokeWidth: 1.22903,
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 21.8645L45.0001 21.8645",
    stroke: "#68131B",
    strokeWidth: 1.22903,
    strokeLinejoin: "bevel"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_865_737",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8414 11.6565) rotate(139.486) scale(31.3152 31.4554)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFC49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFC49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipYellow);
export default __webpack_public_path__ + "static/media/chip-yellow.452447ffe980cf2527ecb64ac8560441.svg";
export { ForwardRef as ReactComponent };